module.exports = __webpack_public_path__ + "img/bacteria.0a849176.jpg";